var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageinfo1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5306 13.3333V9.99996M10.5306 6.66663H10.5389M18.8639 9.99996C18.8639 14.6023 15.133 18.3333 10.5306 18.3333C5.92823 18.3333 2.19727 14.6023 2.19727 9.99996C2.19727 5.39759 5.92823 1.66663 10.5306 1.66663C15.133 1.66663 18.8639 5.39759 18.8639 9.99996Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageinfo1);
export default __webpack_public_path__ + "static/media/messageinfo1.b4c36b53e5e7f6f9da1a7150e5be3c21.svg";
export { ForwardRef as ReactComponent };